export default __webpack_public_path__ + "static/media/complementary--dangerous-or-pollutant-good--g1.3bf88255.png";